
declare var THREE;

class DblclickControls {

    private camera;

    constructor(private sceneElement, private floor, private walls) {
        this.sceneElement.object3D.traverse(item => {
            if (item.type == 'PerspectiveCamera') {
                this.camera = item;
            }
        });
        if (!this.camera) {
            console.warn('DblclickControls: camera not found');
        }
    }

    public activate() {
        const raycaster = new THREE.Raycaster();
        const mouse = new THREE.Vector2();
        let objects = [this.floor.object3D];
        for (let i = 0; i < this.walls.length; i++) {
            objects.push(this.walls[i].object3D);
        }
        this.sceneElement.addEventListener('dblclick', (event) => {
            mouse.x = (event.clientX / this.sceneElement.clientWidth) * 2 - 1;
            mouse.y = -(event.clientY / this.sceneElement.clientHeight) * 2 + 1;
            raycaster.setFromCamera(mouse, this.camera);
            const intersects = raycaster.intersectObjects(objects, true);
            if (intersects.length > 0 && this.isFloorObject(intersects[0].object)) {
                const point = intersects[0].point;
                const cameraWrapper: any = document.getElementById('camera');
                const camera: any = document.querySelector('[wasd-controls]');
                const x = point.x - camera.getAttribute('position').x;
                const z = point.z - camera.getAttribute('position').z;
                cameraWrapper.setAttribute('animation', `property: position; to: ${x} 0 ${z}; dur: 500; easing: easeInOutQuad;`);
            }
        });
    }

    private isFloorObject(object): boolean {
        let isFloor = false;
        this.floor.object3D.traverse(item => {
            if (item.uuid === object.uuid) {
                isFloor = true;
            }
        });
        return isFloor;
    }
}
